import { getLocaleConfig } from "configs/LangConfig"
import { useLocale } from "hooks/useLocale"
import { JSX, PropsWithChildren } from "react"
import { IntlProvider } from "react-intl"

import { Locale } from "@shared/enums/general"

export interface LocaleProviderProps extends PropsWithChildren {
  /**
   *  Optional locale to use. If the local is not provided, then the provider
   *  will deduce the locale via the `useLocale` hook.
   *
   *  Providing a locale is useful in tests to set the locale to a specific value.
   */
  locale?: Locale
}

export const LocaleProvider = ({ children, locale }: LocaleProviderProps): JSX.Element => {
  const deducedLocale = useLocale()
  const resolvedLocale = locale ?? deducedLocale
  const localeConfig = getLocaleConfig(resolvedLocale)

  return (
    <IntlProvider locale={resolvedLocale} messages={localeConfig.messages}>
      {children as JSX.Element}
    </IntlProvider>
  )
}
